import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialPaginationState, PaginationState } from '@redux/helpers';
import {
  CHANNELS_PER_PAGE,
  SHOWS_PER_PAGE,
  USERS_PER_PAGE,
} from '@utils/constants';

type InitialState = {
  shows: PaginationState;
  channels: PaginationState;
  users: PaginationState;
};

export const initialState: InitialState = {
  shows: initialPaginationState,
  channels: initialPaginationState,
  users: initialPaginationState,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setShowsIds: (
      state,
      action: PayloadAction<{ ids: string[]; isRefresh: boolean }>,
    ) => {
      const { ids, isRefresh } = action.payload;

      state.shows.ids = isRefresh
        ? ids
        : Array.from(new Set([...state.shows.ids, ...ids]));
      state.shows.mayLoadMore = ids.length === SHOWS_PER_PAGE;
    },
    setChannelsIds: (
      state,
      action: PayloadAction<{ ids: string[]; isRefresh: boolean }>,
    ) => {
      const { ids, isRefresh } = action.payload;

      state.channels.ids = isRefresh
        ? ids
        : Array.from(new Set([...state.channels.ids, ...ids]));
      state.channels.mayLoadMore = ids.length === CHANNELS_PER_PAGE;
    },
    setUsersIds: (
      state,
      action: PayloadAction<{ ids: string[]; isRefresh: boolean }>,
    ) => {
      const { ids, isRefresh } = action.payload;

      state.users.ids = isRefresh
        ? ids
        : Array.from(new Set([...state.users.ids, ...ids]));
      state.users.mayLoadMore = ids.length === USERS_PER_PAGE;
    },
  },
});

export const { setShowsIds, setChannelsIds } = searchSlice.actions;

export default searchSlice.reducer;
